import React from 'react';
import { Navigate } from 'react-router-dom';
import {
  clearAuthStorage,
  hasActiveSession,
  hasRoleOrPermission,
} from "../utils/authUtils";

const ProtectedRoute = ({ children, allowedRoles = [], requiredPermission = "" }) => {
  // Gate on the session (refresh token), not the access token — an expired
  // access token is renewed transparently by the axios interceptor.
  if (!hasActiveSession()) {
    clearAuthStorage();
    return <Navigate to="/login" replace />;
  }

  const userRole = localStorage.getItem('role_name')?.toLowerCase();
  
  // If no specific roles are allowed, grant access
  if (allowedRoles.length === 0 && !requiredPermission) {
    return children;
  }
  
  // Check if the user's role or explicit permission grants access.
  if (hasRoleOrPermission(allowedRoles, requiredPermission)) {
    return children;
  }
  
  // Redirect Field Technicians to their dashboard
  if (userRole === 'field technician') {
    return <Navigate to="/field-technician-welcome" replace />;
  }
  
  // Redirect other unauthorized users to Projects
  return <Navigate to="/Projects" replace />;
};

export default ProtectedRoute;
